export const CREATE_VEHICLE_UPAD = 'CREATE_VEHICLE_UPAD';
export const GET_VEHICLE_UPAD = 'GET_VEHICLE_UPAD';
export const VEHICLE_UPAD_REQUEST = 'VEHICLE_UPAD_REQUEST';
export const UPDATE_VEHICLE_UPAD = 'UPDATE_VEHICLE_UPAD';
export const DELETE_VEHICLE_UPAD = 'DELETE_VEHICLE_UPAD';
export const VEHICLE_UPAD_REQUEST_FAILURE = 'VEHICLE_UPAD_REQUEST_FAILURE';